import React from 'react'
import { PrismicRichText } from '@prismicio/react'
import CtaLink from './CtaLink'
import { slugify } from '../../util/strings'
import * as Styled from './styles/FeaturedProductBlock.styles'

const FeaturedProductBlock = ({ data }) => {
  const headerText = data.header?.text || 'Featured Product'
  const product = data.product?.document?.data
  const productImage = product?.product_image?.url ?? null
  const companyData = product?.product_company?.document?.data
  const allowDetailPages = companyData?.product_detail_pages_allowed === true

  const linkHref = allowDetailPages
    ? `/seal-of-recognition/${slugify(companyData.product_company)}/${slugify(
        product.product_name.text
      )}`
    : product?.product_link?.url

  const link = allowDetailPages
    ? {
        url: linkHref,
        type: 'product_detail_page',
        link_type: 'Document',
        id: null,
        uid: linkHref,
      }
    : product?.product_link

  const productCtaText =
    product?.product_cta_text?.text || 'Learn More About This Product'

  return (
    <Styled.ContentGrid>
      <Styled.FeaturedProductBlock>
        <Styled.Header>
          <Styled.Title>{headerText}</Styled.Title>
        </Styled.Header>
        <Styled.ProductDetailRow>
          {productImage && (
            <Styled.ProductImage>
              <img src={productImage} alt={data.product_image?.alt ?? ''} />
            </Styled.ProductImage>
          )}
          <Styled.ProductTextColumn>
            <Styled.ProductTitle>
              <PrismicRichText field={product?.product_name?.richText} />
            </Styled.ProductTitle>
            <Styled.ProductBrand>
              {product?.product_company?.document?.data?.product_company}
            </Styled.ProductBrand>
            <Styled.ProductDescription>
              <PrismicRichText field={product?.product_description?.richText} />
            </Styled.ProductDescription>
            <CtaLink
              text={productCtaText}
              link={link}
              additionalStyles={Styled.additionalCtaStyles}
            />
          </Styled.ProductTextColumn>
        </Styled.ProductDetailRow>
      </Styled.FeaturedProductBlock>
    </Styled.ContentGrid>
  )
}

export default FeaturedProductBlock
